export const translationKeys = {
  all: ['translations'] as const,
  byLocale: (locale: string) => ['translations', 'byLocale', locale] as const
};
